import { api } from './api';

export const bibliotecaService = {
  getMiBiblioteca,
  postBiblioteca,
  putBiblioteca,
  getBibliotecaCompartido,
  putBibliotecaCompartido,
  eliminarBiblioteca,
  getBibliotecaDescarga,
  getBibliotecaPeso,
  getBibliotecaCompartidaConmigo
};

function getBibliotecaCompartidaConmigo(data){
  return api.post(
    api.tx.getBibliotecaCompartidaConmigo, 
    data
  ).then(data => {
    return data;
  });
}

function getBibliotecaPeso(data){
  return api.post(
    api.tx.getBibliotecaPeso, 
    data
  ).then(data => {
    return data;
  });
}

function getBibliotecaDescarga(data){
  return api.post(
    api.tx.getBibliotecaDescarga, 
    data
  ).then(data => {
    return data;
  });
}

function eliminarBiblioteca(data){
  return api.post(
    api.tx.eliminarBiblioteca, 
    data
  ).then(data => {
    return data;
  });
}

function getBibliotecaCompartido(data){
  return api.post(
    api.tx.getBibliotecaCompartido, 
    data
  ).then(data => {
    return data;
  });
}

function putBibliotecaCompartido(data){
  return api.post(
    api.tx.putBibliotecaCompartido, 
    data
  ).then(data => {
    return data;
  });
}

function getMiBiblioteca(data){
  return api.post(
    api.tx.getMiBiblioteca, 
    data
  ).then(data => {
    return data;
  });
}

function postBiblioteca(data){
  return api.post(
    api.tx.postBiblioteca, 
    data
  ).then(data => {
    return data;
  });
}

function putBiblioteca(data){
  return api.post(
    api.tx.putBiblioteca, 
    data
  ).then(data => {
    return data;
  });
}